// extracted by mini-css-extract-plugin
export var bold = "_rl-0";